export default __webpack_public_path__ + "static/media/ommuseBackgroundMobile.e3d2b783.png";